enum Mutation {
  INSERT_PARENT_NODE = 'insertParentNode',
  REPLACE_PARENT_NODE = 'replaceParentNode',
  SET_CREATE_ID_COUNTER = 'setCreateIdCounter',
  SET_IS_DIRTY = 'setIsDirty',
  SET_TREE = 'setTree',
}

export default Mutation;
